import { Types } from '../constants/actionTypes';

const initialState = {
    user: {
        "id": false,
        "display_name": "",
        "user_nicename": "",
        "user_photo": "",
        "user_url": "",
        "description": "",
        "tag": "",
        "rate": "",
        "token": "",
        "user_email": "",
        "value": []
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.LOGIN:
            return {
                ...state,
                user: action.payload,
            }
        default:
            return state;
    }
}

export default reducer;